export const DEFAULT_OPACITY = [0.0, 0.1, 0.25, 0.4, 0.5, 0.65, 0.7, 0.8, 0.9, 1.0];
